import { useEffect, useState } from "react";
import CausasAssistencia from "../../services/service.causas.assistencia";
import NewSearchBarControlFormik from "../searchs_comp/search-Bar.Control.Formik";
import { GetIdiomaSelecionado } from "../../config/localstorageConfig/localstorage";
import { GetIdiomaFiltro } from "../../config/axiosConfig/http-common";


const CamposSearchCausa = (props) => {

    const [tipoAssistencia, setTipoAssistencia] = useState();
    const [pages, setPages] = useState();
    const [filter, setFilter] = useState();



    const idioma = GetIdiomaFiltro();
    const { idCliente,constantes } = props;

    const columns = [
        {
            field: 'Id',
            headerName: constantes?.Codigo,
            width: 90,
            key: true
        },
        {
            field: 'Nome',
            headerName: constantes?.Causa,
            width: 90,
        },
    ]

    const columnsFilter = [
        {
            field: 'Id',
            headerName: constantes?.Codigo,
            tipo: 'number'
        },
        {
            field: 'Nome',
            headerName: constantes?.Nome,
            tipo: 'text'
        }
    ]


    function onLoad(loading) {
        props.onLoad(loading)
    }

    function onError(error) {
        props.onError(error)
    }

    function onSearchTitle(filter) {
        onLoad(true);
        CausasAssistencia.getAll(filter)
            .then(response => {
                const tiposdeassistencia = response.data.value
                
                setTipoAssistencia(tiposdeassistencia);
                setPages(response.data.pages);
                setFilter(filter);
            })
            .catch(e => {
                onError(e);
            })
            .finally(() => {
                onLoad(false);
            });
    }

   function onGetItem(id) {
        id && onLoad(true);
        id && CausasAssistencia.getId(id)
            .then(response => {
                if (response.response?.data.error) {
                   onError(response.response?.data.error);
                } else {
                    // const traducao = ProdutoService.getProdutoTraduzido(response.data);
                    // const produto = { ...response.data, Nome: traducao };
                   response.data && onItemSelected(response.data);
                }
            })
            .catch(e => {
                onError(e);
            })
            
            .finally(() => {
                onLoad(false);
            });
    }

    function onItemSelected(item) {
        props.onItemSelected(item);
    }

    return (
        <>
            <NewSearchBarControlFormik
                {...props}
                fullscreen
                pages={pages}
                onSearchTitle={onSearchTitle}
                onGetItem={onGetItem}
                onItemSelected={onItemSelected}
                data={tipoAssistencia}
                columns={columns}
                storagename={"Causa"}
                columnsFilter={columnsFilter}
            />
        </>
    )
}

export default CamposSearchCausa;
